var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#07D3C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.9961V21.9961H6",
    stroke: "#20528B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.9961V9.99609H26",
    stroke: "#20528B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2516 9.99609C23.6309 11.433 24.4732 13.3012 24.637 15.2862C24.8007 17.2713 24.2759 19.2521 23.1507 20.8957C22.0255 22.5392 20.3687 23.7451 18.4588 24.3106C16.549 24.8761 14.5027 24.7666 12.6641 24.0005",
    stroke: "#20528B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74678 22.0002C8.3705 20.5626 7.53079 18.6951 7.36867 16.7115C7.20654 14.7278 7.73187 12.7488 8.85644 11.1067C9.98101 9.46467 11.6363 8.25953 13.5445 7.69369C15.4526 7.12785 17.4973 7.23578 19.3352 7.99935",
    stroke: "#20528B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeAvatarIcon);
export default __webpack_public_path__ + "static/media/ChangeAvatarIcon.4a32bef4e8884cd0a8e56d2362b7fa16.svg";
export { ForwardRef as ReactComponent };